import { useSelector } from 'react-redux';
import { isRequiredFeatureEnabled } from 'src/components/auth';
import { NavbarPermissions } from 'src/components/organisms';
import { FeatureFlag, State, User } from 'src/types';

export const useCanAccessSpeakUp = (): boolean => {
  const hasSpeakUpPermission = useSelector((state: State) =>
    Boolean(
      (state.globalUsers?.currentUser as User)?.systemPermissions?.includes(
        NavbarPermissions.NAV_CASES,
      ),
    ),
  );
  const features = useSelector(({ features }: State) => features);

  return (
    hasSpeakUpPermission &&
    isRequiredFeatureEnabled(features, FeatureFlag.SPEAK_UP)
  );
};
